import { mutatorAction } from 'satcheljs';
import { getFolderTable } from 'owa-folders';
/**
 * Mutator to add folder in folder table for the deeplink view
 */
var loadPopoutDataToFolderStore = mutatorAction('loadPopoutDataToFolderStore', function (popoutData) {
    var folderId = popoutData.folderId, treeType = popoutData.treeType, permission = popoutData.permission;
    var folderTable = getFolderTable();
    if (!folderTable.get(folderId)) {
        var folder = {
            FolderId: { Id: folderId },
            treeType: treeType,
            PermissionSet: { Permissions: [permission] },
        };
        folderTable.set(folderId, folder);
    }
});
export default loadPopoutDataToFolderStore;
//# sourceMappingURL=loadPopoutDataToFolderStore.js.map